import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { BscConnector } from '@binance-chain/bsc-connector';

// interfaces
import { BlockChainNetwork } from '@/interfaces';

// constants
import { SUPPORTED_CHAINS } from '@/constants/chains';

const POLLING_INTERVAL = 5000;

// eslint-disable-next-line no-shadow
export enum ConnectorNames {
  Injected = `injected`,
  WalletConnect = `walletconnect`,
  BSC = `bsc`,
}

const connector = (blockChainNetwork: BlockChainNetwork) => {
  const BSCSupportedChains = {
    walletconnect: [SUPPORTED_CHAINS[2], SUPPORTED_CHAINS[3]],
    injected: [SUPPORTED_CHAINS[2], SUPPORTED_CHAINS[3]],
    network: [SUPPORTED_CHAINS[2], SUPPORTED_CHAINS[3]],
  };

  const EthereumSupportedChains = {
    walletconnect: [SUPPORTED_CHAINS[0]],
    injected: [SUPPORTED_CHAINS[0], SUPPORTED_CHAINS[1]],
    network: [SUPPORTED_CHAINS[0]],
  };

  const SupportedChains =
    blockChainNetwork === `Ethereum`
      ? EthereumSupportedChains
      : BSCSupportedChains;

  // list connectors rpcs
  const rpc = SupportedChains.walletconnect.reduce((acc, curr) => {
    // eslint-disable-next-line prefer-destructuring
    (acc as any)[+curr.chainId] = curr.rpcUrls[0];
    return acc;
  }, {});

  const injected = new InjectedConnector({
    supportedChainIds: [
      ...SupportedChains.injected.map((chain) => +chain.chainId),
    ],
  });

  const binanceConnector = new BscConnector({
    supportedChainIds: [
      ...SupportedChains.injected.map((chain) => +chain.chainId),
    ],
  });

  const walletconnect = new WalletConnectConnector({
    rpc,
    bridge: `https://bridge.walletconnect.org`,
    qrcode: true,
    pollingInterval: POLLING_INTERVAL,
  });

  const connectorsByName: {
    [connectorName in ConnectorNames]: any;
  } = {
    [ConnectorNames.Injected]: injected,
    [ConnectorNames.WalletConnect]: walletconnect,
    [ConnectorNames.BSC]: binanceConnector,
  };

  return {
    injected,
    walletconnect,
    binanceConnector,
    connectorsByName,
  };
};

export default connector;
